import Lookup from 'src/componentes/select-async';
import FuncaoEdit from 'src/paginas/remuneracao-variavel/funcoes/edit';
import FuncaoList from 'src/paginas/remuneracao-variavel/funcoes/view';

const FuncaoLookup = (props) => {
  return (
    <Lookup
      valueKey="id"
      labelKey="nome"
      showSearch
      clearable={true}
      url="/FuncaoLookup"
      editComponent={FuncaoEdit}
      searchComponent={FuncaoList}
      {...props}
    />
  );
};

export default FuncaoLookup;
